import { useState } from 'react';

export default function FAQContent() {
  // Start with no accordion open; using null makes the intent clear.
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: 'How long does it take to get a construction layout quote in Vancouver?',
      answer:
        'At Dinari Designs, we provide professional layout and formwork quotes within 24-48 hours for projects across the Lower Mainland and Victoria.',
    },
    {
      question: 'What software is used for professional formwork detailing?',
      answer:
        'We utilize industry-standard AutoCAD for high-precision 2D drafting and Bluebeam Revu for accurate material takeoffs and digital document coordination.',
    },
    {
      question: 'Is it better to hire a full-time layout specialist or a contractor?',
      answer:
        'For most firms, hiring a specialized contractor like Dinari Designs is more cost-effective. It eliminates the overhead of full-time salaries, benefits, and software licenses while providing on-demand expertise.',
    },
    {
      question: 'What cities in the Lower Mainland do you serve?',
      answer:
        'Dinari Designs provides professional construction layout and formwork services across the entire Lower Mainland, including Vancouver, Burnaby, Surrey, Coquitlam, New Westminster, Langley, Richmond, and Delta.',
    },
    {
      question: 'Do you provide construction layout services in Coquitlam and New Westminster?',
      answer:
        'Yes. Dinari Designs offers expert AutoCAD layout and formwork detailing for high-density and residential projects throughout Coquitlam and New Westminster. We understand the unique terrain challenges and municipal requirements of these hillside and urban riverfront areas.',
    },
    {
      question: 'Can you support new developments in Langley and the Fraser Valley?',
      answer:
        'Absolutely. With the rapid expansion in Langley and the surrounding Fraser Valley, we provide on-demand technical detailing to help developers keep pace with tight timelines. Our contract-based model is ideal for firms looking to scale their capacity without adding full-time staff.',
    },
    {
      question: 'What is the benefit of hiring a contract specialist for Lower Mainland projects?',
      answer:
        'By contracting your detailing to Dinari Designs, you eliminate the overhead costs associated with a full-time employee—including benefits, payroll taxes, and AutoCAD licenses. This "Lean Construction" approach allows firms in Vancouver, Surrey, and Burnaby to stay competitive and agile.',
    },
    {
      question: 'How fast can I get a layout quote for a project in Richmond or Delta?',
      answer:
        "We offer a 24-48 hour turnaround for project quotes across Richmond, Delta, and the entire Lower Mainland. Our goal is to ensure your project doesn\\'t stall waiting for technical documentation.",
    },
    {
      question: 'How does contracting layout work save money for developers in Coquitlam and Langley?',
      answer:
        'Hiring a contract specialist eliminates the high fixed costs of a full-time employee, such as benefits, workstation hardware, and annual AutoCAD software licenses, allowing for a more flexible project budget.',
    },
    {
      question: 'Do you offer on-site consultations in New Westminster and the Fraser Valley?',
      answer:
        'Yes, we offer on-demand technical consultations and site planning for projects in New Westminster, Langley, and throughout the Fraser Valley.',
    },
  ];

  // Toggle accordion panels safely
  const handleToggle = (index: number) => {
    setOpenIndex(prev => (prev === index ? null : index));
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-slate-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-slate-600">
            Everything you need to know about our Lower Mainland construction services
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-slate-50 rounded-xl overflow-hidden border border-slate-200 hover:border-teal-300 transition-colors"
            >
              <button
                onClick={() => handleToggle(index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-slate-100 transition-colors"
              >
                <h3 className="text-lg font-semibold text-slate-900 pr-4">
                  {faq.question}
                </h3>
                <div className="flex items-center justify-center w-8 h-8 flex-shrink-0">
                  <i
                    className={`ri-arrow-down-s-line text-2xl text-teal-600 transition-transform ${
                      openIndex === index ? 'rotate-180' : ''
                    }`}
                  ></i>
                </div>
              </button>
              {openIndex === index && (
                <div className="px-6 pb-5">
                  <p className="text-slate-700 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <p className="text-lg text-slate-600 mb-6">
            Have more questions about our services?
          </p>
          <a
            href="#contact"
            className="inline-block bg-teal-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-teal-700 transition-colors whitespace-nowrap"
          >
            Get Your Free Quote
          </a>
        </div>
      </div>
    </section>
  );
}
